import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userComponent from './user.component';
import userDetailModule from './userDetails/userDetails';

const userModule = angular
  .module('user', [uiRouter, userDetailModule])
  .component('user', userComponent)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('main.user', {
      url: '/usuarios',
      component: 'user',
    });
  }).name;

export default userModule;



// WEBPACK FOOTER //
// ./client/app/components/user/user.js